import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import Auth0Lock from 'auth0-lock';
import { Store } from '@ngrx/store';
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '../../../environments/environment';
import * as fromRoot from '..';
import { Observable } from 'rxjs/Observable';
import { UserProfile } from '../auth/user-profile';
import { LoginAction, LogoutAction } from '../auth/auth.actions';
import { identifierModuleUrl } from '@angular/compiler';
import { Profile } from 'selenium-webdriver/firefox';
import { FirestoreService } from '../../shared/firestore/firestore.service';
import { IUser } from '../../shared/firestore/models/user';
import { IProject } from '../../shared/firestore/models/project';

export const LOCALSTORAGE_TOKEN_NAME = 'auth0_id_token';

@Injectable()
export class AuthService {
  private lock: any;
  private userProfile: any;

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private jwtHelper: JwtHelperService,
    private firestore: FirestoreService,
  ) {
    const config = environment.auth0;
    this.lock = new Auth0Lock(config.clientId, config.domain, {
      auth: {
        params: {
          scope: 'openid email picture'
        },
        redirect: false,
        responseType: 'id_token',
        sso: false,
      },
      autoclose: true,
      theme: {
        labeledSubmitButton: false,
        logo: '../../../assets/images/counthing.png',
        primaryColor: 'green',
      },
      languageDictionary: {
        title: 'カウントちゃん',
      },
    });
    this.lock.on('authenticated', (authResult) => {
      localStorage.setItem(LOCALSTORAGE_TOKEN_NAME, authResult.idToken);
      this.entry(authResult.idToken);
      this.router.navigate(['/']);
    });
  }

  getIdToken(): string {
    return localStorage.getItem(LOCALSTORAGE_TOKEN_NAME);
  }

  public login() {
    this.lock.show({
      allowedConnections: ['google-oauth2'],
      socialButtonStyle: 'big',
      autoclose: true,
    });
  }

  public authenticate(): boolean {
    if (this.authenticated()) {
      this.entry();
      return true;
    }
    return false;
  }

  public authenticated(): boolean {
    const idToken = this.getIdToken();
    if (idToken) {
      return !this.jwtHelper.isTokenExpired(idToken);
    }
    return false;
  }

  public logout() {
    localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME);
    this.store.dispatch(new LogoutAction());
  }

  getUserProfile(): Observable<UserProfile> {
    return this.store.select<UserProfile>(state => state.auth.profile);
  }

  private entry(idToken = null) {
    idToken = idToken ? idToken : this.getIdToken();
    const userInfo = this.jwtHelper.decodeToken(idToken);
    const userProfile = <UserProfile>{
      userId: userInfo.sub,
      email: userInfo.email,
      emailVerified: userInfo.email_verified,
    };
    this.store.dispatch(new LoginAction(userProfile));
    const firestoreUser = this.firestore.findUser(userProfile.userId);
    firestoreUser.data$.subscribe(user => {
      if (user == null) {
        // 新規登録
        const project = this.firestore.addProject(<IProject>{
          name: 'My Project',
          ownerUserId: userProfile.userId,
          userIds: [userProfile.userId],
        });
        this.firestore.addUser(userProfile.userId, <IUser>{
          email: userProfile.email,
          mainProjectId: project.id,
          projectIds: [project.id],
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/services/auth.service.ts